// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `First Name`
};

const de_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `Vorname`
};

const es_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `Nombre`
};

const fr_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `Prénom`
};

const fi_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `Etunimi`
};

const hi_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `पहला नाम`
};

const ja_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `名`
};

const nl_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `Voornaam`
};

const pt_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `Primeiro Nome`
};

const ro_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `Prenume`
};

const th_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `ชื่อจริง`
};

const ur_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `پہلا نام`
};

const zh_hant1_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `名字`
};

const da_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `Fornavn`
};

const it_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `Nome`
};

const vn_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `Tên`
};

const ko_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `이름`
};

const tr_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `Ad`
};

const lv_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `Vārds`
};

const ar_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `الاسم الأول`
};

const bs_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `Ime`
};

const sl_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `Ime`
};

const id_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `Nama Depan`
};

const sv_widget_login_first_name = /** @type {(inputs: {}) => string} */ () => {
	return `Förnamn`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "fi" | "hi" | "ja" | "nl" | "pt" | "ro" | "th" | "ur" | "zh-Hant" | "da" | "it" | "vn" | "ko" | "tr" | "lv" | "ar" | "bs" | "sl" | "id" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const widget_login_first_name = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.widget_login_first_name(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("widget_login_first_name", locale)
	if (locale === "en") return en_widget_login_first_name(inputs)
	if (locale === "de") return de_widget_login_first_name(inputs)
	if (locale === "es") return es_widget_login_first_name(inputs)
	if (locale === "fr") return fr_widget_login_first_name(inputs)
	if (locale === "fi") return fi_widget_login_first_name(inputs)
	if (locale === "hi") return hi_widget_login_first_name(inputs)
	if (locale === "ja") return ja_widget_login_first_name(inputs)
	if (locale === "nl") return nl_widget_login_first_name(inputs)
	if (locale === "pt") return pt_widget_login_first_name(inputs)
	if (locale === "ro") return ro_widget_login_first_name(inputs)
	if (locale === "th") return th_widget_login_first_name(inputs)
	if (locale === "ur") return ur_widget_login_first_name(inputs)
	if (locale === "zh-Hant") return zh_hant1_widget_login_first_name(inputs)
	if (locale === "da") return da_widget_login_first_name(inputs)
	if (locale === "it") return it_widget_login_first_name(inputs)
	if (locale === "vn") return vn_widget_login_first_name(inputs)
	if (locale === "ko") return ko_widget_login_first_name(inputs)
	if (locale === "tr") return tr_widget_login_first_name(inputs)
	if (locale === "lv") return lv_widget_login_first_name(inputs)
	if (locale === "ar") return ar_widget_login_first_name(inputs)
	if (locale === "bs") return bs_widget_login_first_name(inputs)
	if (locale === "sl") return sl_widget_login_first_name(inputs)
	if (locale === "id") return id_widget_login_first_name(inputs)
	if (locale === "sv") return sv_widget_login_first_name(inputs)
	return "widget_login_first_name"
};